module.exports = __webpack_public_path__ + "static/images/jf-coupon-bg02.cbd2ed3.png";